/**
 * @generated SignedSource<<a7616fe55064603edf5fa9d4cd510e25>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SelectKeyResultDropdownQuery$variables = {
  assignedTo?: ReadonlyArray<string> | null;
  cycles?: ReadonlyArray<string> | null;
  titleIncludingObjectives?: string | null;
};
export type SelectKeyResultDropdownQuery$data = {
  readonly keyResults: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly objective: {
          readonly title: string;
        };
        readonly title: string;
      };
    } | null>;
  } | null;
};
export type SelectKeyResultDropdownQuery = {
  response: SelectKeyResultDropdownQuery$data;
  variables: SelectKeyResultDropdownQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assignedTo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cycles"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "titleIncludingObjectives"
},
v3 = [
  {
    "kind": "Variable",
    "name": "assignedTo",
    "variableName": "assignedTo"
  },
  {
    "kind": "Variable",
    "name": "cycles",
    "variableName": "cycles"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  },
  {
    "kind": "Variable",
    "name": "titleIncludingObjectives",
    "variableName": "titleIncludingObjectives"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectKeyResultDropdownQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "KeyResultsConnection",
        "kind": "LinkedField",
        "name": "keyResults",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyResultsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyResult",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Objective",
                    "kind": "LinkedField",
                    "name": "objective",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SelectKeyResultDropdownQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "KeyResultsConnection",
        "kind": "LinkedField",
        "name": "keyResults",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "KeyResultsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyResult",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Objective",
                    "kind": "LinkedField",
                    "name": "objective",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f41e0720dbf8f90226ae0a7b2dbbe840",
    "id": null,
    "metadata": {},
    "name": "SelectKeyResultDropdownQuery",
    "operationKind": "query",
    "text": "query SelectKeyResultDropdownQuery(\n  $titleIncludingObjectives: String\n  $assignedTo: [ID!]\n  $cycles: [ID!]\n) {\n  keyResults(titleIncludingObjectives: $titleIncludingObjectives, assignedTo: $assignedTo, cycles: $cycles, first: 25) {\n    edges {\n      node {\n        id\n        title\n        objective {\n          title\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c18f3953c57451a9e04ed101851cba61";

export default node;
